import React from 'react';
import { useTranslation } from 'react-i18next';
import { Utils } from '../../services';
import MultiSelectField from '../MultiSelectField/MultiSelectField';

import './AccountingTypesField.css';

const AccountingTypesField = ({ name, placeholder }) => {
    const { t } = useTranslation();

    const options = Utils.accountingTypes().map(type => {
        return {
            key: type,
            text: t(`accounting.types.${type}`),
            value: type
        };
    });

    return <MultiSelectField
        name={ name }
        options={ options }
        placeholder={ placeholder }
    />
}

export default AccountingTypesField;
